const INITIAL_STATE = {
  roles: [],
};

export const Creators = {
  addRoles: roles => ({
    type: 'ADD_ROLES',
    roles,
  }),
};

export default function rolesReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'ADD_ROLES':
      return {
        ...state,
        roles: action.roles,
      };

    default:
      return state;
  }
}
